module.exports = __webpack_public_path__ + "static/media/passive_index_keyinsight_1.6a723b49.svg";